export default __webpack_public_path__ + "static/media/09476f2530188d8505372efe4dadfc59.svg";